import React, { useEffect, useCallback, useState} from 'react';
import Force from './Force.js';
import {connect} from 'react-redux';

const Forces = ({forces}) => { 
    let numForces = Object.keys(forces).length;
    return (
        <div className="script-forces">
          {numForces > 0 &&
           <div className="forces-label">
             Forces
           </div>}
          {Object.keys(forces).map(
              name => <Force name={name} force={forces[name]}/>)}
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
      forces: props.effect.forces
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Forces);
